module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center",
    attrs: {
      "id": "adc"
    }
  }, [_c('strong', [_vm._v("Other books by Leland Gregory")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("What’s the Number for 911?")]), _c('br'), _c('em', [_vm._v("What’s the Number for 911 Again?")]), _c('br'), _c('em', [_vm._v("The Stupid Crook Book")]), _c('br'), _c('em', [_vm._v("Hey, Idiot!")]), _c('br'), _c('em', [_vm._v("Idiots at Work")]), _c('br'), _c('em', [_vm._v("Bush-Whacked")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-665a6444","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740792069_epub_adc_r1.vue
// module id = 63
// module chunks = 0